import { Injectable } from '@angular/core';
import { StatColor } from './stat.model';

export const STAT_COLORS: readonly StatColor[] = [
  'destructive',
  'success',
  'warning',
  'neutral',
  'primary',
];

/**
 * Hands out accent colors to the insight cards currently rendered so that a
 * color is only reused once every color in the palette is already on screen.
 */
@Injectable({ providedIn: 'root' })
export class StatColorAllocatorService {
  private readonly usage = new Map<StatColor, number>(
    STAT_COLORS.map(color => [color, 0])
  );

  acquire(): StatColor {
    const color = STAT_COLORS.reduce((least, current) =>
      this.usage.get(current)! < this.usage.get(least)! ? current : least
    );
    this.usage.set(color, this.usage.get(color)! + 1);
    return color;
  }

  release(color: StatColor): void {
    this.usage.set(color, Math.max(0, this.usage.get(color)! - 1));
  }
}
